const COMMON = {
	REDUX_ACTION: {
		LOGOUT: "LOGOUT",
	},
	EVENTS: {
		APP: "APP",
		LOADED: "LOADED",
		FAILED: "FAILED",
		SUCCESS: "SUCCESS",
		LOGOUT: "LOGOUT",
	},
	REDUX_PRESIST_KEY: "root_hr_employee_6a46285d-e323-48ae-8a84-e1bc036f0223",
	AUTH_TOKEN: "altecflex_hr_employee_@99e53932-f4d8-46fc-9bba-757fd5e32783_auth_tk",
	REFRESH_TOKEN: "altecflex_hr_employee_@273f71f5-0d2d-45cd-b93b-fee2c84aea7b_refresh_tk",
	ENDPOINT_PATH: {
		GENERAL: {
			LOGO: "general/logo",
			LIST: "general/lookup/detail",
			PROFILE: "general/profile/whoami",
			UPLOAD_AVATAR: "general/profile/avatar",
			COMPANY: "general/profile/company/detail",
			COMPANIES: "general/profile/company/list",
			CITIES: "general/public/address/city/page",
			STATES: "general/public/address/state/page",
			POSTCODE: "general/public/address/postcode/",
			REFRESH_TOKEN: "authentication/public/token/refresh",
			MAINTENANCE: "service/config/config.json",
			SEND_OTP: "general/profile/change-password/email/otp-code",
			SEND_RESET_PASSWORD_OTP: "general/reset-password/email/otp-code",
			VERIFY_RESET_PASSWORD_OTP: "general/reset-password/otp-verify",
			VERIFY_OTP: "general/profile/change-password/otp-verify",
			UPDATE_PASSWORD: "general/profile/change-password/update",
			RESET_PASSWORD: "general/reset-password/reset",
		},
		NOTIFICATION: {
			LIST: "general/notification/list",
			UNREAD_COUNT: "general/notification/unread-count",
			MARK_AS_READ: "general/notification/mark-as-read/",
			MARK_ALL_AS_READ: "general/notification/mark-all-as-read",
		},
		APPOINTMENT: {
			LIST: "general/employee-appointment/page",
			APPOINTMENTS_UPDATE: "general/employee-appointment/update-appointment-status",
		},
		ASSIGNMENT: {
			UPDATE_STATUS: "general/assignment/update-status/",
			UPLOAD_DOCUMENT: "general/assignment/upload-cert/",
			ONGOING_LIST: "general/assignment/ongoing/page",
			LIST: "general/assignment/page",
		},
		CERTIFICATE: {
			LIST: "general/certificate/page",
		},
		DASHBOARD: {
			EMPLOYEE: "general/employee",
		},
		AUTHENTICATE: {
			USER: "general/profile/company/",
			SIGN_IN: "authentication/public/token/",
			EMPLOYEE_SIGN_IN: "authentication/public/token/employeeRequestToken",
			SIGN_UP: "authentication/public/signup",
			SEND_OTP: "authentication/public/verification/email",
			CREATE_PASSWORD: "authentication/public/signup/password",
			VERIFY_OTP: "authentication/public/verification/otp-verify",
		},
		LEAVES: {
			CALENDAR: "general/calendar/",
			TIME_OFF: "general/time-off-types/",
			LIST: "general/employee-leave/page",
			REQUEST_LIST: "general/employee-leave/leave-request",
			DIRECTORY_LIST: "general/employee-leave/directory",
			MANAGER_SUMMARY_LIST: "general/employee-leave/manager-summary",
			MANAGER_UPCOMING_LIST: "general/employee-leave/manager-upcoming",
			MANAGER_HISTORY_LIST: "general/employee-leave/manager-history",
			MANAGER_VIEW_DETAILS_LIST: "general/employee-leave/view-details",
			REJECT: "general/leave-approval/reject-manager",
			APPROVE: "general/leave-approval/approve-manager",
			LEAVE: "general/employee-leave/details/",
			CREATE: "general/leave-application/apply",
			SUMMARY: "general/employee-leave/summary",
			CANCEL: "general/leave-application/cancel/",
			UPCOMING: "general/employee-leave/upcoming/page",
			UPLOAD_DOCUMENT: "general/leave-application/upload/",
			LEAVE_TYPES: "benefit/company-benefit-package/get-my-package",
			CALCULATE_END_DATE: "general/leave-application/calculate-end-date",
		},
		HOLIDAY_CALENDAR: {
			REGIONS: "general/holiday-calendar/regions",
			YEAR: "general/holiday-calendar/year/",
		},
		OVERTIME: {
			APPLY: "general/employee-overtime/apply",
			UPLOAD: "general/employee-overtime/upload/",
			CANCEL: "general/employee-overtime/cancel",
			PENDING: "general/employee-overtime/pending",
			HISTORY: "general/employee-overtime/history",
			DETAILS: "general/employee-overtime/details/",
			BALANCE: "general/employee-overtime/replacement-leave-balance",
			MANAGER_PENDING: "general/employee-overtime/manager/pending",
			MANAGER_HISTORY: "general/employee-overtime/manager/history",
			MANAGER_SEARCH: "general/employee-overtime/manager/search",
			MANAGER_DETAILS: "general/employee-overtime/manager/details/",
			MANAGER_APPROVE: "general/employee-overtime/manager/approve",
			MANAGER_REJECT: "general/employee-overtime/manager/reject",
		},
		BENEFITS: {
			LIST: "benefit/company-benefit-package/page",
		},
		CLAIMS: {
			HISTORY: "claim/employee-claim/page",
			SUMMARY: "claim/employee-claim/summary",
			CLAIM: "claim/employee-claim/details/",
			CREATE: "claim/claim-application/submit",
			UPLOAD_DOCUMENT: "claim/claim-application/upload/",
			CANCEL: "claim/claim-application/cancel/",
			CLAIM_TYPES: "benefit/company-benefit-package/get-my-package",
		},
		EMPLOYEE: {
			ORGANISATION: "employee/user-company",
			EMPLOYEE_INFO: "employee/detail/employee-info",
			PERSONAL_INFO: "employee/detail/personal-info",
			EMPLOYEE_DOCUMENT: "employee/detail/employee-document",
			UPDATE_PERSONAL_INFO: "employee/update/personal-info",
			UPDATE_EMPLOYEE_INFO: "employee/update/employee-info",
			GET_FIRST_TIME_EMPLOYEE_INFO: "employee/",
			UPDATE_FIRST_TIME_EMPLOYEE_INFO: "employee/update",
		},
	},
	REGEX: {
		SYMBOL: /(\W|_)/,
		NUMERIC: /(?=.*\d)/,
		ALPHABETIC: /^[A-Za-z/ ]+$/,
		LOWERCASE: /(?=.*[a-z])/,
		UPPERCASE: /(?=.*[A-Z])/,
		EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	},
	MASKING: {
		NRIC: "******-**-****",
	},
	IDENTIFICATION_TYPE: {
		NRIC: "NRIC",
		PASSPORT: "PASSPORT",
	},
	DROPDOWNS: {
		EXAM_STATUS: [
			{ label: "Pass", value: "COMPLETED"},
			{ label: "Fail", value: "FAILED"},
		],
		GENDER: [
			{ label: "Male", value: "MALE" },
			{ label: "Female", value: "FEMALE" },
		],
		LEAVES_STATUS: [
			{ label: "Working", value: "WORKING" },
			{ label: "On Leave", value: "ON_LEAVE" },
		],
		APPOINTMENT: [
			{ label: "Upcoming", value: "UPCOMING" },
			{ label: "Acknowledged", value: "ACKNOWLEDGED" },
			{ label: "Completed", value: "COMPLETED" },
			{ label: "Cancelled", value: "CANCELLED" },
			{ label: "Overdue", value: "OVERDUE" },
		],
		NATIONALITY: [
			{ label: "Malaysian", value: "MALAYSIAN" },
			{ label: "Foreigner", value: "FOREIGNER" },
		],
		MARITAL_STATUS: [
			{ label: "Single", value: "SINGLE" },
			{ label: "Married", value: "MARRIED" },
			{ label: "Divorced or Widowed", value: "DIVORCED_OR_WIDOWED" },
		],
		OVERTIME_STATUS: [
			{ label: "Pending Admin Approval", value: "PENDING_ADMIN" },
			{ label: "Approved", value: "APPROVED" },
			{ label: "Rejected", value: "REJECTED" },
			{ label: "Cancelled", value: "CANCELLED" },
		],
		OVERTIME_REJECT_REASON: [
			{ label: "Duplicated OT", value: "DUPLICATED_OT" },
			{ label: "Not covered by HR Policy", value: "NOT_COVERED_BY_HR_POLICY" },
			{ label: "Late Submission", value: "LATE_SUBMISSION" },
			{ label: "Others", value: "OTHERS" },
		],
	},
	OVERTIME: {
		REJECT_REASON: {
			OTHERS: "OTHERS",
		},
	},
	BENEFITS: {
		DAYS: {
			CALENDAR_DAYS: "CALENDAR_DAYS",
			WORKING_DAYS: "WORKING_DAYS",
		},
		LEAVES: {
			ANNUAL_LEAVE: "ANNUAL_LEAVE",
			SICK_LEAVE: "SICK_LEAVE",
			PATERNITY_LEAVE: "PATERNITY_LEAVE",
			MATERNITY_LEAVE: "MATERNITY_LEAVE",
			HOSPITALISATION_LEAVE: "HOSPITALISATION_LEAVE",
			CARRY_FORWARD_LEAVE: "CARRY_FORWARD_LEAVE",
			REPLACEMENT_LEAVE: "REPLACEMENT_LEAVE",
		},
		LEAVE_LABELS: {
			REPLACEMENT_LEAVE: "Replacement Leave",
		},
		LEAVE_SHORT_FORMS: {
			ANNUAL_LEAVE: "AL",
			SICK_LEAVE: "SL",
			PATERNITY_LEAVE: "PL",
			MATERNITY_LEAVE: "ML",
			HOSPITALISATION_LEAVE: "HL",
			CARRY_FORWARD_LEAVE: "CFL",
			COMPASSIONATE_LEAVE: "CL",
			REPLACEMENT_LEAVE: "RL",
			MARRIAGE_LEAVE: "MRL",
			EMERGENCY_LEAVE: "EL",
			UNPAID_LEAVE: "UPL",
		},
		CLAIMS: {
			MEDICAL_CLAIM: "MEDICAL_CLAIM",
			BODYCHECK_OPTICAL_DENTAL_CLAIM: "BODYCHECK_OPTICAL_DENTAL_CLAIM",
			OTHER_CLAIM: "OTHER_CLAIM",
		},
	},
	MAX_FILE_SIZE: 5000000,
	APP_STATUS: {
		NEW: "new",
	},
	STATUS_ID: {
		ACTIVE: "ACTIVE",
		INACTIVE: "INACTIVE",
		DELETED: "DELETED",
		DISABLED: "DISABLED",
		EXPIRED: "EXPIRED",
		PENDING: "PENDING",
		REJECTED: "REJECTED",
		SUCCEEDED: "SUCCEEDED",
		CANCELLED: "CANCELLED",
		ACCEPTED: "ACCEPTED",
		FAILED: "FAILED",
		READ: "READ",
		NOT_READ: "NOT_READ",
		WORKING: "WORKING",
		ON_LEAVE: "ON_LEAVE",
		APPROVED: "APPROVED",
		PROBATION: "PROBATION",
		INTERN: "INTERN",
		COMPLETED: "COMPLETED",
		PERMANENT: "PERMANENT",
		TERMINATION: "TERMINATION",
		RESIGNED: "RESIGNED",
		OVERDUE: "OVERDUE",
		DISMISSAL: "DISMISSAL",
		CONVERSATION_ENDED: "CONVERSATION_ENDED",
		FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
		UPCOMING: "UPCOMING",
		ACKNOWLEDGED: "ACKNOWLEDGED",
		ASSIGNED: "ASSIGNED",
		READY: "READY",
		PENDING_MANAGER: "PENDING_MANAGER",
		PENDING_ADMIN: "PENDING_ADMIN",
	},
	STATUS_CODE: {
		TOKEN_EXPIRED: "HRC_000011",
		INVALID_TOKEN: "HRC_000016",
		REFRESH_TOKEN_EXPIRED: "HRC_000017",
		USER_BLOCKED: "HRC_000018",
		MAXIMUM_PASSWORD_ATTEMPTS: "HRC_UAA_00010",
		
		/* -- overtime compensation -- */
		OVERTIME_NOT_FOUND: "HR_OVERTIME_000001",
		OVERTIME_INVALID_TIME: "HR_OVERTIME_000002",
		OVERTIME_DUPLICATED: "HR_OVERTIME_000003",
		OVERTIME_NO_REPORTING_MANAGER: "HR_OVERTIME_000004",
		OVERTIME_INVALID_ALLOWANCE: "HR_OVERTIME_000005",
		OVERTIME_INSUFFICIENT_REPLACEMENT_LEAVE: "HR_OVERTIME_000006",
		RECORD_NOT_FOUND: "HR_LEAVE_000003",
		FILE_LIMIT_EXCEEDED: "HR_LEAVE_000006",
		USER_UNAUTHORIZED: "HR_LEAVE_000007",
		REJECT_REASON_MISSING: "HR_LEAVE_000010",
		OPERATION_NOT_PERMITTED: "HR_LEAVE_000011",
	},
	TABLE_REQUEST_STATUS: {
		INSTANCE: "INSTANCE",
	},
};

export default COMMON;
